import React from "react";
import DashboardLayout from "../DashboardLayout";
import OrderPlacementForm from "./OrderPlacementForm";

export default function OrderPlacementPage() {
  return (
    <DashboardLayout>
      <div className="flex flex-col items-center justify-center relative w-full max-h-screen text-white">
        This is Order Placement Form
        {/* <OrderPlacementForm /> */}
      </div>
    </DashboardLayout>
  );
}
